import { createSlice } from "@reduxjs/toolkit";

const CURRENCY = 'selected-currency';

const localCurrency = localStorage.getItem(CURRENCY);

const initialState = {
    selectedCurrency: localCurrency || 'USD',
    supportedCurrencies: []
};

const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrency(state, { payload }) {
            state.selectedCurrency = payload;
            localStorage.setItem(CURRENCY, payload);
        },
        setSupportedCurrencies(state, { payload }) {
            state.supportedCurrencies = payload;
        },
        setCurrencyMetadata(state, { payload }) {
            state.currencyMetadata = payload;
        }
    }
});

export const { setCurrency, setSupportedCurrencies,setCurrencyMetadata } = currencySlice.actions;
export default currencySlice.reducer;
